import { render, staticRenderFns } from "./MenuBlog.vue?vue&type=template&id=0bcc3b62&scoped=true"
import script from "./MenuBlog.vue?vue&type=script&lang=js"
export * from "./MenuBlog.vue?vue&type=script&lang=js"
import style0 from "./MenuBlog.vue?vue&type=style&index=0&id=0bcc3b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc3b62",
  null
  
)

export default component.exports